import { ElementType, forwardRef } from 'react';
import { css, cx } from '@linaria/atomic';
import { motion, AnimatePresence, MotionProps } from 'motion/react';
import { FlyoutMenuProps } from './types';

export type AnimatedMenuProps = Omit<FlyoutMenuProps, 'actions' | 'onClose'> &
  MotionProps & {
    as?: keyof JSX.IntrinsicElements;
    className?: string;
  };

const animatedMenuBaseStyle = css`
  background: white;
  list-style-type: none;
  margin: 0;
  padding: 0;
  position: absolute;
`;

export const AnimatedMenu = forwardRef<HTMLElement, AnimatedMenuProps>(
  ({ children, as = 'ul', className, ...rest }, ref) => {
    const Component = motion[as] as ElementType;
    return (
      <AnimatePresence>
        <Component className={cx(animatedMenuBaseStyle, className)} ref={ref} {...rest}>
          {children}
        </Component>
      </AnimatePresence>
    );
  }
);

AnimatedMenu.displayName = 'AnimatedMenu';
